import { render, staticRenderFns } from "./BemButton.vue?vue&type=template&id=466b43f0&lang=pug"
import script from "./BemButton.vue?vue&type=script&lang=js"
export * from "./BemButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports